import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { ThemeService } from 'src/app/core/services/theme/theme.service';

@Component({
  selector: 'app-pill',
  templateUrl: './pill.component.html',
  styleUrls: ['./pill.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PillComponent {
  @Input({ required: true }) label!: string;
  themeService = inject(ThemeService);
}
